/** 현장 안전 웨어러블 알림 — 시스템 설정 UI / API */

export type WearableAlertTarget = 'pool_active_devices' | 'connected_only';
export type WearableVibratePattern = 'short' | 'long' | 'pulse' | 'sos';

export interface WearableAlertSettings {
  enabled: boolean;
  default_selected: boolean;
  target: WearableAlertTarget;
  vibrate_pattern: WearableVibratePattern;
  alert_duration_sec: number;
  include_pool_name: boolean;
  broadcast_pool_websocket: boolean;
  message_type: string;
}

export const DEFAULT_WEARABLE_ALERT_SETTINGS: WearableAlertSettings = {
  enabled: true,
  default_selected: true,
  target: 'pool_active_devices',
  vibrate_pattern: 'pulse',
  alert_duration_sec: 15,
  include_pool_name: true,
  broadcast_pool_websocket: true,
  message_type: 'safety_alert',
};

export function mergeWearableAlertSettings(
  partial?: Partial<WearableAlertSettings> | null
): WearableAlertSettings {
  const p = partial || {};
  const d = DEFAULT_WEARABLE_ALERT_SETTINGS;
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  const num = (v: unknown, fallback: number) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };
  const targetRaw = String(p.target || d.target).toLowerCase();
  const target: WearableAlertTarget =
    targetRaw === 'connected_only' ? 'connected_only' : 'pool_active_devices';
  const vibRaw = String(p.vibrate_pattern || d.vibrate_pattern).toLowerCase();
  const vibrate_pattern: WearableVibratePattern =
    vibRaw === 'short' || vibRaw === 'long' || vibRaw === 'sos' ? vibRaw : 'pulse';
  return {
    enabled: bool(p.enabled, d.enabled),
    default_selected: bool(p.default_selected, d.default_selected),
    target,
    vibrate_pattern,
    alert_duration_sec: Math.min(120, Math.max(3, Math.floor(num(p.alert_duration_sec, d.alert_duration_sec)))),
    include_pool_name: bool(p.include_pool_name, d.include_pool_name),
    broadcast_pool_websocket: bool(p.broadcast_pool_websocket, d.broadcast_pool_websocket),
    message_type: String(p.message_type ?? d.message_type).trim() || d.message_type,
  };
}
